import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {Popover} from 'shells/popover/popover';
import {PopoverForm} from 'shells/popover-form/popover-form';

import {PipelineSelectPicker} from '../../../core/form/fields/pipeline-select-picker';

type Props = {
    anchor: HTMLElement | null | undefined;
    selectedStagesetId: string;
    onClose: () => any;
    onChangeStageset: (newStagesetId: string) => void | PromiseLike<unknown>;
};

export function PipelineSelectPopover(props: Props) {
    const [selectedStagesetId, setSelectedStagesetId] = React.useState<string>(
        props.selectedStagesetId
    );
    const [isSaving, setIsSaving] = React.useState(false);

    const handleSubmit = () => {
        setIsSaving(true);
        Promise.resolve(props.onChangeStageset(selectedStagesetId)).finally(() => {
            setIsSaving(false);
        });
    };

    return (
        <Popover anchor={props.anchor} location='bottom'>
            <PopoverForm
                width={250}
                height={150}
                onClose={props.onClose}
                title='Change pipeline'
                isSaving={isSaving}
                saveButtonSavingText='Saving…'
                saveButtonSuccessText='Success'
                onSubmit={handleSubmit}
                saveButtonText='Change pipeline'
            >
                {/* @ts-expect-error */}
                <FormField innerId='stagesetId' formField='Pipeline'>
                    <PipelineSelectPicker
                        minHeight={39}
                        autoselectDefault={true}
                        selectedPipeline={selectedStagesetId}
                        onSelectPipeline={(id: string) => setSelectedStagesetId(id)}
                    />
                </FormField>
            </PopoverForm>
        </Popover>
    );
}
